<template>
  <!-- 课时统计 -->
  <div class="classSchedule">
    <!-- 顶部搜索 -->
    <el-form class="select" label-width="130px">
      <el-form-item label="日期:">
        <el-date-picker clearable value-format="yyyy-MM" type="month" v-model="classDate" placeholder="选择日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="教师姓名:">
        <el-input placeholder="请选择教师姓名" v-model="teacherName" clearable></el-input>
      </el-form-item>
      <el-form-item label="课次数:">
        <el-input placeholder="请输入课次数" v-model="classNum" clearable></el-input>
      </el-form-item>
      <el-form-item label="上课频率:">
        <el-input placeholder="请输入上课频率" v-model="classFrequency" clearable></el-input>
      </el-form-item>
      <el-form-item label="周末课时数:">
        <el-input placeholder="请输入周末课时数" v-model="classWeekendNum" clearable></el-input>
      </el-form-item>
      <el-form-item label="学生请假次数:">
        <el-input placeholder="请输入学生请假次数" v-model="studentLeaveNum" clearable></el-input>
      </el-form-item>
      <el-form-item label="首次课成功率:">
        <el-input placeholder="请输入首次课成功率" v-model="classFirstSuccessRate" clearable></el-input>
      </el-form-item>
      <el-form-item label="人员变动次数:">
        <el-input placeholder="请输入人员变动次数" v-model="personChangesNum" clearable></el-input>
      </el-form-item>
      <el-form-item label="五次课成功率:">
        <el-input placeholder="请输入五次课成功率" v-model="classFiveSuccessRate" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="clearBtn" class="btns" size="small" icon="el-icon-close">清除</el-button>
        <el-button type="primary" @click="searchBtn" size="small" class="btns" icon="el-icon-search">搜索</el-button>
        <el-button type="primary" @click="count" icon="el-icon-thumb" size="small" class="btns">一键计算</el-button>
      </el-form-item>
    </el-form>
    <!-- table表格 -->
    <el-table :tree-props="{ children: 'children' }"   :data="dataList" border :cell-style="styleBack" style="width: 100%;margin-bottom: 20px;" row-key="childId" height="700">
      <el-table-column width="130" prop="classDate" label="日期">
      </el-table-column>
      <el-table-column width="120" label="教师姓名" prop="teacherName">
        <!-- <template slot-scope="scope">
          <span @click="teacherNames">
            {{ scope.row.teacherName }}
          </span>
        </template> -->
      </el-table-column>
      <el-table-column prop="classNum" label="课次数" width="150">
      </el-table-column>
      <el-table-column width="130" prop="classFrequency" label="上课频率(到课率)">
      </el-table-column>
      <el-table-column width="100" label="周末课时数">
        <template slot-scope="scope">
          <span style="cursor: pointer;" @click="weekend(scope.row)">
            {{ scope.row.classWeekendNum }}
          </span>
        </template>
      </el-table-column>
      <el-table-column width="110" prop="studentLeaveNum" label="学生请假次数">
      </el-table-column>
      <el-table-column label="首次课数">
        <template slot-scope="scope">
          <router-link
            :to="`/FirstClassHistory/${scope.row.id}/${scope.row.teacherId}/${scope.row.teacherName}/${scope.row.childId}`">
            {{ scope.row.classFirstNum }}
          </router-link>
        </template>
      </el-table-column>
      <el-table-column prop="classFirstSuccessRate" width="120" label="首次课成功率">
      </el-table-column>
      <el-table-column label="五次课数">
        <template slot-scope="scope">
          <router-link
            :to="`/FiveClass/${scope.row.id}/${scope.row.teacherId}/${scope.row.teacherName}/${scope.row.childId}`">
            {{ scope.row.classFiveNum }}
          </router-link>
        </template>
      </el-table-column>
      <el-table-column width="120" prop="classFiveSuccessRate" label="五次课成功率">
      </el-table-column>
      <el-table-column width="150" prop="classTrimesterFirstRate" label="三个月首次课成功率">
      </el-table-column>
      <el-table-column width="110" prop="personChangesNum" label="人员变动次数">
      </el-table-column>
      <el-table-column header-align="center" label="操作" fixed="right" width="150px">
        <template slot-scope="scope" v-if="scope.row.id != null">
          <!-- <el-button type="text" @click="edit(scope.row.id)">编辑</el-button> -->
          <el-button type="text" @click="detail(scope.row.id)">详情</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
      :current-page="requestParameters.pageNum" :page-size="requestParameters.pageSize"
      layout="prev, pager, next,sizes, jumper" :total="total">
    </el-pagination>
    <!-- 点击周末课时数 -->
    <el-dialog :visible.sync="isShow" width="30%">
      <p class="classWeekendNum" v-for="(item, index) in classWeekendDetailList" :key="index">
        <span>日期:{{ item.date }}</span> 数量:{{ item.num }}
      </p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="isShow = false">取 消</el-button>
        <el-button type="primary" @click="isShow = false">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 编辑详情弹窗 -->
    <el-dialog :title="isFlog ? '课时统计编辑' : '课时统计详情'" :visible.sync="dialogFormVisible">
      <el-form label-width="150px">
        <el-form-item label="日期:" style="text-align: left;">
          <el-date-picker v-model="editObj.classDate" style="width: 100%;" v-if="isFlog" value-format="yyyy-MM"
            type="month" placeholder="请选择日期">
          </el-date-picker>
          <span v-else>{{ editObj.classDate }}</span>
        </el-form-item>
        <el-form-item label="教师姓名:" style="text-align: left;">
          <!-- <el-select size="small" v-if="isFlog" v-model="editObj.teacherName" placeholder="全部教师" style="width: 100%;"
            clearable>
            <el-option style="margin-left: 10px;" v-for="teacher in teachers" :key="teacher.id" :label="teacher.realname"
              :value="teacher.id">
            </el-option>
          </el-select> -->
          <el-input v-if="isFlog" v-model="editObj.teacherName" placeholder="请输入教师姓名" autocomplete="off"></el-input>
          <span v-else>{{ editObj.teacherName }}</span>
        </el-form-item>
        <el-form-item label="课次数:" style="width: 100%; text-align: left;">
          <el-input v-if="isFlog" v-model="editObj.classNum" placeholder="请输入课次数" autocomplete="off"></el-input>
          <span v-else>{{ editObj.classNum }}</span>
        </el-form-item>
        <el-form-item label="上课频率:" style="width: 100%; text-align: left;">
          <el-input v-if="isFlog" v-model="editObj.classFrequency" placeholder="请输入上课频率" autocomplete="off"></el-input>
          <span v-else>{{ editObj.classFrequency }}</span>
        </el-form-item>
        <el-form-item label="周末课时数:" style="width: 100%; text-align: left;">
          <el-input v-if="isFlog" v-model="editObj.classWeekendNum" placeholder="请输入周末课时数" autocomplete="off"></el-input>
          <span v-else>{{ editObj.classWeekendNum }}</span>
        </el-form-item>
        <el-form-item label="学生请假次数:" style="width: 100%; text-align: left;">
          <el-input v-if="isFlog" v-model="editObj.studentLeaveNum" placeholder="请输入学生请假次数" autocomplete="off"></el-input>
          <span v-else>{{ editObj.studentLeaveNum }}</span>
        </el-form-item>
        <el-form-item label="首次课数:" style="width: 100%; text-align: left;">
          <el-input v-if="isFlog" v-model="editObj.classFirstNum" placeholder="请输入课次数" autocomplete="off"></el-input>
          <span v-else>{{ editObj.classFirstNum }}</span>
        </el-form-item>
        <el-form-item label="首次课成功率:" style="width: 100%; text-align: left;">
          <el-input v-if="isFlog" v-model="editObj.classFirstSuccessRate" placeholder="请输入首次课成功率"
            autocomplete="off"></el-input>
          <span v-else>{{ editObj.classFirstSuccessRate }}</span>
        </el-form-item>
        <el-form-item label="五次课数:" style="width: 100%; text-align: left;">
          <el-input v-if="isFlog" v-model="editObj.classFiveNum" placeholder="请输入五次课数" autocomplete="off"></el-input>
          <span v-else>{{ editObj.classFiveNum }}</span>
        </el-form-item>
        <el-form-item label="五次课成功率:" style="width: 100%; text-align: left;">
          <el-input v-if="isFlog" v-model="editObj.classFiveSuccessRate" placeholder="请输入五次课成功率"
            autocomplete="off"></el-input>
          <span v-else>{{ editObj.classFiveSuccessRate }}</span>
        </el-form-item>
        <el-form-item label="三个月首次课成功率:" style="width: 100%; text-align: left;">
          <el-input v-if="isFlog" v-model="editObj.classTrimesterFirstRate" placeholder="请输入三个月首次课成功率"
            autocomplete="off"></el-input>
          <span v-else>{{ editObj.classTrimesterFirstRate }}</span>
        </el-form-item>
        <el-form-item label="人员变动次数:" style="width: 100%; text-align: left;">
          <el-input v-if="isFlog" v-model="editObj.personChangesNum" placeholder="请输入人员变动次数"
            autocomplete="off"></el-input>
          <span v-else>{{ editObj.personChangesNum }}</span>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="determine">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import apiBaseUrl from "../../../config/api";
export default {
  data () {
    // const stashStr = localStorage.getItem('stash')
    // const stash = stashStr ? JSON.parse(stashStr) : {}
    return {
      classWeekendDetailList: [],
      total: 0,
      isShow: false,
      dialogFormVisible: false,//控制编辑弹窗
      requestParameters: {
        pageSize: 10, //每页多少条
        pageNum: 1, //当前显示页码
      },
      // flog: false,//点击老师姓名出现表格
      isFlog: true,//编辑还是详情
      classDate: "",//日期搜索
      teacherName: "",//老师姓名
      classNum: "",//课次数
      classFrequency: "",//上课频率
      classWeekendNum: "",//周末课时数
      studentLeaveNum: "",//学生请假次数
      classFirstSuccessRate: "",//首次课成功率
      personChangesNum: "",//人员变动次数
      classFiveSuccessRate: "",//五次课成功率
      teachers: [],//所有老师
      //编辑绑定字段
      editObj: {
        classDate: "",//日期
        classFirstNum: "",//首次课数
        teacherName: "",//老师姓名
        classNum: "",//课次数
        classFrequency: "",//上课频率
        classWeekendDetailList: "",//周末课时数
        studentLeaveNum: "",//学生请假次数
        classFirstSuccessRate: "",//首次课成功率
        classFiveNum: "",//五次课数
        classFiveSuccessRate: "",//五次课成功率
        classTrimesterFirstRate: "",//三个月首次课成功率
        personChangesNum: "",//人员变动次数
      },
      dataList: [],
    }
  },
  beforeRouteLeave (to, from, next) {
    //   to.meta.keepAlive = true;  //我理解的是 to 是发送  from 是接收
    //   next();

    //   // 此处也可以加判断
    //   if (from.name === "FiveClass") {
    //     to.meta.keepAlive = true;
    //  } else {
    //    to.meta.keepAlive = false;
    //   }
    if (to.name !== 'FiveClass' || to.name !== "FirstClassHistory") {
      from.meta.keepAlive = false
    }
    next();
  },
  created () {
    this.getListData()
  },
  methods: {
    //一键计算
    count () {
      axios
        .get(`${apiBaseUrl}/courseStatistic/courseStatistic?yearMonth=${this.classDate}`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        }) // 请替换为你的API URL
        .then(res => {
          if (res.data.code == 200) {
            this.$message.success(res.data.message)
            this.getListData()
          } else {
            this.$message.error(res.data.message)
          }
        })
        .catch(error => {
          console.error(error);
        });
    },
    //编辑详情保存
    determine () {
      axios
        .post(`${apiBaseUrl}/courseStatistic/updateStatistic`, this.editObj,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        }) // 请替换为你的API URL
        .then(response => {
          if (response.data.code == 200) {
            this.$message.success("修改成功")
          } else {
            this.$message.error("修改失败")
          }
        })
        .catch(error => {
          console.error(error);
        });
      this.getListData()
      this.dialogFormVisible = false
    },
    //搜索
    searchBtn () {
      let data = {
        classDate: this.classDate,
        teacherName: this.teacherName,
        classNum: this.classNum,
        classFrequency: this.classFrequency,
        classWeekendNum: this.classWeekendNum,
        studentLeaveNum: this.studentLeaveNum,
        classFirstSuccessRate: this.classFirstSuccessRate,
        personChangesNum: this.personChangesNum,
        classFiveSuccessRate: this.classFiveSuccessRate,
        studentLeaveNum: this.studentLeaveNum,
      }
      axios
        .post(`${apiBaseUrl}/courseStatistic/getList`, data,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        }) // 请替换为你的API URL
        .then(response => {
          if (response.data.code == 200) {
            this.$message.success(response.data.message)
            this.dataList = response.data.data.records
            this.total = response.data.data.total
            for (var i = 0; i < this.dataList.length; i++) {
              if (this.dataList[i].monthPlanDetail == null) {
                this.dataList[i]['children'] = []
              } else {
                this.dataList[i]['children'] = [this.dataList[i].monthPlanDetail]
              }
            }
            localStorage.setItem('stash', JSON.stringify(this.$data))
          } else {
            this.$message.error('搜索失败')
          }
        })
        .catch(error => {
          console.error(error);
        });
    },
    //获取table表数据
    getListData () {
      let obj = {
        classDate: this.classDate,
        pageNum: this.requestParameters.pageNum,
        pageSize: this.requestParameters.pageSize
      }
      axios
        .post(`${apiBaseUrl}/courseStatistic/getList`, obj,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        }) // 请替换为你的API URL
        .then(response => {
          this.dataList = response.data.data.records
          this.total = response.data.data.total
          for (var i = 0; i < this.dataList.length; i++) {
            if (this.dataList[i].monthPlanDetail == null) {
              this.dataList[i]['children'] = []
            } else {
              this.dataList[i]['children'] = [this.dataList[i].monthPlanDetail]
            }
          }
        })
        .catch(error => {
          console.error(error);
        });
    },
    //获取所有老师
    fetchTeachers () {
      axios
        .get(`${apiBaseUrl}/schedule/teacherlist`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        }) // 请替换为你的API URL
        .then(response => {
          this.teachers = response.data.data; // 将获取的数据赋值给teachers数组
        })
        .catch(error => {
          console.error(error);
        });
    },
    handleSizeChange (pageSize) {
      this.requestParameters.pageSize = pageSize;
      if (this.requestParameters.page === 1) {

      }
      this.getListData(this.requestParameters);
    },
    // 进入某一页
    handleCurrentChange (newPage) {
      this.requestParameters.pageNum = newPage;
      this.getListData();
    },
    //设置某一格子文字颜色
    styleBack (data) {
      if (data.columnIndex == 6 || data.columnIndex == 4 || data.columnIndex == 8) {
        return { color: "#0c87ef" };
      }
    },
    //编辑
    // edit (id) {
    //   this.isFlog = true
    //   this.dialogFormVisible = true
    //   axios
    //     .get(`${apiBaseUrl}/courseStatistic/getDetail?id=${id}`)
    //     .then(response => {
    //       if (response.data.code == 200) {
    //         this.editObj = response.data.data
    //       }
    //     })
    //     .catch(error => {
    //       console.error(error);
    //     });

    // },
    // gb () {
    //   this.flog = false
    // },
    //详情
    detail (id) {
      this.isFlog = false
      this.dialogFormVisible = true
      axios
        .get(`${apiBaseUrl}/courseStatistic/getDetail?id=${id}`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then(response => {
          if (response.data.code == 200) {
            this.editObj = response.data.data
          }
        })
        .catch(error => {
          console.error(error);
        });

    },
    //点击教师名字
    // teacherNames () {
    //   this.flog = true
    // },
    // //点击首次课
    // firstNum (row) {
    //   // console.log(row);
    // },
    // //点击五次课数
    // fiveClass () {
    //   console.log('五次课数');
    // },
    //点击周末课时数
    //清除按钮
    clearBtn () {
      this.classFiveSuccessRate = "",
        this.personChangesNum = "",
        this.classFirstSuccessRate = "",
        this.studentLeaveNum = "",
        this.classWeekendNum = "",
        this.classFrequency = "",
        this.updateDate = "",
        this.teacherName = "",
        this.classNum = "",
        this.classDate = ""
      this.getListData()
    },
    weekend (data) {
      this.isShow = true
      this.classWeekendDetailList = data.classWeekendDetailList
    }
  },
}
</script>

<style scoped>
.select {
  display: flex;
  flex-wrap: wrap;
}

.showTable {
  width: 85%;
  background-color: #fff;
  position: absolute;
  top: 393px;
  z-index: 20;
  box-shadow: 5px 5px 5px 5px #ccc;
}

.classWeekendNum {
  display: flex;
  justify-content: space-around;
}

@media screen and (max-width: 750px) {
  .classSchedule {
    /* overflow: auto; */
    width: 1430px;
  }

  /* 兼容移动端 */
  #aa>>>.classSchedule {
    width: 70% !important;
  }

  .classSchedule>>>.el-dialog {
    width: 100% !important;
  }
}

.btns{
  background-color: #428BCA;
  border-color: #428BCA;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/manager/components/ClassSchedule.vue